/* eslint-disable @typescript-eslint/explicit-function-return-type */
/* eslint-disable @typescript-eslint/no-unused-vars */
import * as React from 'react';
import type { SVGProps } from 'react';
const SingleSizeIllustrationFeedbackDefaultSad = (
  props: SVGProps<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 42 42"
    data-xds="SingleSizeIllustrationFeedbackDefaultSad"
    role="presentation"
    {...props}
  >
    <g clipPath="url(#clip0_10198_373)">
      <path
        fill="var(--xdlColorIllustrationOutlineSecondary)"
        d="M21 42c11.598 0 21-9.402 21-21S32.598 0 21 0 0 9.402 0 21s9.402 21 21 21"
      />
      <path
        fill="#fff"
        fillRule="evenodd"
        d="M27.87 18.75c2.25 0 4.27 1 5.65 2.58a7.45 7.45 0 0 1-5.65 2.58c-2.26 0-4.27-1-5.65-2.58a7.45 7.45 0 0 1 5.65-2.58M14.59 18.75c2.25 0 4.27 1 5.65 2.58a7.45 7.45 0 0 1-5.65 2.58c-2.26 0-4.27-1-5.65-2.58a7.45 7.45 0 0 1 5.65-2.58"
        clipRule="evenodd"
      />
      <path
        fill="#1D2124"
        d="M41 21C41 9.954 32.046 1 21 1S1 9.954 1 21s8.954 20 20 20v1C9.402 42 0 32.598 0 21S9.402 0 21 0s21 9.402 21 21-9.402 21-21 21v-1c11.046 0 20-8.954 20-20"
      />
      <path
        fill="#1D2124"
        d="M27.39 17.23c-1.48 0-3.22-.45-5.13-1.77l.57-.82c4.1 2.83 7.19 1.29 8.68.13l.62.79c-.82.65-2.49 1.68-4.73 1.68zM15.14 17.23c-1.48 0-3.22-.45-5.13-1.77l.57-.82c4.1 2.82 7.19 1.29 8.68.13l.62.79c-.82.65-2.49 1.68-4.73 1.68z"
      />
      <path
        fill="#1D2124"
        fillRule="evenodd"
        d="M33.9 20.99a7.965 7.965 0 0 0-12.04 0l-.29.33.29.33a7.965 7.965 0 0 0 12.04 0l.29-.33zm-6.03 2.41c-.87 0-1.72-.17-2.52-.48.23-.03.47-.09.69-.19 1.29-.58 1.87-2.1 1.29-3.39-.01-.03-.04-.04-.05-.07.19-.02.39-.03.58-.03 1.87 0 3.66.75 4.96 2.08a7 7 0 0 1-4.96 2.08zM14.59 18.25c-2.31 0-4.5 1-6.02 2.75l-.29.33.29.33a7.965 7.965 0 0 0 12.04 0l.29-.33-.29-.33a7.97 7.97 0 0 0-6.02-2.75m0 5.15c-.87 0-1.72-.17-2.52-.48.23-.03.47-.09.69-.19 1.29-.58 1.87-2.1 1.29-3.39-.01-.03-.04-.04-.05-.07.19-.02.39-.03.58-.03 1.87 0 3.66.75 4.96 2.08a7 7 0 0 1-4.96 2.08z"
        clipRule="evenodd"
      />
      <path
        fill="#1D2124"
        d="m18.39 30.3-.65-.76c2.71-2.3 6.23-3.55 8.21-3.48l-.02 1c-1.8-.06-5.11 1.18-7.55 3.24z"
      />
    </g>
    <defs>
      <clipPath id="clip0_10198_373">
        <path fill="#fff" d="M0 0h42v42H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SingleSizeIllustrationFeedbackDefaultSad;
